import axios from "axios";
import Cookies from "universal-cookie";
import { isLoggedIn } from "./users.service";

let cookies = new Cookies();

const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

http.interceptors.response.use(
  function (response) {
    // Do something before the request is sent
    return response;
  },
  async function (error) {
    // Handle the error
    if (error.response.status === 401) {
      try {
        const data = await isLoggedIn();
        if (!data.isLogged) {
          throw new Error("user is not logged");
        }
      } catch (err) {
        cookies.remove("access_token", {
          path: "/",
          domain: process.env.REACT_APP_DOMAIN,
        });
        return window.location.replace("/SEABC/login");
      }
    }
    return Promise.reject(error);
  },
);

http.defaults.withCredentials = true;

export default http;
